<template>
    <div>
        <HeaderUnlogged v-if="$ff('new-unlogged-navbar')" />
        <Navbar v-else />

        <section class="hero-banner">
            <h1>{{ $t('gdpr.privacy.cover.title') }}</h1>
        </section>

        <slot />

        <FooterUnlogged />
    </div>
</template>

<script setup lang="ts">
    import {FooterUnlogged, Navbar, HeaderUnlogged} from '#components';
    import {use3rdParties} from '#imports';

    use3rdParties();
</script>
<style lang="scss" scoped>
    .hero-banner {
        background-color: var(--joy-color-secondary-90);
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--joy-color-neutral-10);
        text-align: center;
        letter-spacing: 0.2rem;
    }
</style>
